import React, { useEffect } from 'react';

// Transient notification (auto-dismisses). type: 'error' | 'success' | 'info'.
export default function Toast({ message, type = 'info', onClose, duration = 4000 }) {
  useEffect(() => {
    if (!message) return undefined;
    const t = setTimeout(() => onClose && onClose(), duration);
    return () => clearTimeout(t);
  }, [message, duration, onClose]);

  if (!message) return null;
  return (
    <div className="toast-wrap">
      <div className={`toast toast-${type}`} onClick={() => onClose && onClose()}>
        {message}
      </div>
    </div>
  );
}
